import { onlineManager, useQueryClient } from '@tanstack/react-query';
import { getCachedSelfAppDataOptions } from './user-query-options';

/**
 * Returns a callback that revalidates the current-user (self app data) query.
 * No-op while offline
 *
 * @param exact - When true (default), invalidates only the current-user query;
 *   pass false to also invalidate any parametrised variants.
 */
export const useRefreshCurrentUser = (exact: boolean = true) => {
  const queryClient = useQueryClient();

  return () => {
    if (!onlineManager.isOnline()) return Promise.resolve();
    return queryClient.invalidateQueries({
      queryKey: getCachedSelfAppDataOptions().queryKey,
      exact,
    });
  };
};
